import { render } from "./Footer-vue.vue?vue&type=template&id=52c65cb0&scoped=true"
import script from "./Footer-vue.vue?vue&type=script&lang=js"
export * from "./Footer-vue.vue?vue&type=script&lang=js"

import "./Footer-vue.vue?vue&type=style&index=0&id=52c65cb0&lang=scss&scoped=true"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52c65cb0"]])

export default __exports__